module.exports = "<ui-form-element\n        [title]=\"title\"\n        [description]=\"description\"\n        [controlFlex]=\"flex\"\n        [highlightPhrase]=\"highlightPhrase\">\n    <ui-select [(ngModel)]=\"innerValue\"\n               [class.flex-centered]=\"innerCentered\"\n               [id]=\"id\"\n               [list]=\"list\"\n               [disabled]=\"disabled\">\n    </ui-select>\n    <ng-content></ng-content>\n</ui-form-element>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-select/fe-select.html
// module id = 1086
// module chunks = 3